// LAY THONG TIN HE THONG RAP
export const getInfoTheaterRequest = "GET_INFO_THEATER_REQUEST";
export const getInfoTheaterSuccess = "GET_INFO_THEATER_SUCCESS";
export const getInfoTheaterFail = "GET_INFO_THEATER_FAIL";
// LAY THONG TIN CUM RAP THEO HE THONG
export const getTheaterToSystemRequest = "GET_THEATER_TO_SYSTEM_REQUEST";
export const getTheaterToSystemSuccess = "GET_THEATER_TO_SYSTEM_SUCCESS";
export const getTheaterToSystemFail = "GET_THEATER_TO_SYSTEM_FAIL";
